'use client'

import { EmptyState } from '@/features/shop/components/EmptyState'
import styled from 'styled-components'

// href makes "Continue shopping" a real link. without it the button pushes the
// store's search page on click, as it always has.
export const NoDataState = ({ href }: { href?: string }) => (
  <EmptyStateContainer>
    <EmptyState
      text="Sorry, we are having trouble loading this page."
      subText="In the meantime..."
      href={href}
    />
  </EmptyStateContainer>
)
const EmptyStateContainer = styled.div`
  margin-top: 6rem;
`
